// extracted by mini-css-extract-plugin
export var carrierIcon = "_v9-0";
export var carrierLogo = "_v9-1";
export var detailsSection = "_v9-2";